module.exports = __webpack_public_path__ + "img/ic_exception.a5942bae.png";